// eslint-disable-next-line
/// <reference path="./styled.d.ts" />

import { DENSE_LIGHT_THEME } from './theme';

export default DENSE_LIGHT_THEME;
export * from './theme';
export * from './types';
export * from './OptimusProvider';
